import styled from 'styled-components'
import { Row as YogaRow } from '@gympass/yoga'

import { Paragraph } from '@components/Text'
import SMBContainer from '@components/Container'

import getBreakpoint from '@client/utils/breakpoints'

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 479px;
    margin-left: auto;
    margin-right: auto;
  }
`
export const Row = styled(YogaRow)`
  min-height: 400px;
  height: calc(100vh - 285px);
  align-items: center;
`

export const Header = styled.header`
  background-color: var(--white);
`

export const Title = styled.h1`
  font-style: normal;
  font-weight: 500;
  line-height: 38px;
  font-size: 40px;
  font-family: Rubik;
  margin-top: 0;
`

export const Text = styled(Paragraph)`
  font-weight: normal;
  line-height: 24px;
  color: var(--secondary-text);
  margin-top: 16px;
  font-family: Rubik;

  strong {
    margin-left: 4px;
  }
`

export const TextEmail = styled.span`
  font-weight: 500;
`

export const Link = styled(Paragraph)`
  flex: 1;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  color: var(--vibin);
  margin-top: 64px;
  font-family: Rubik;
`
